
      import {
        compileIvritToOpenQasm,
        IVRIT_OPENQASM_GATES,
      } from "./src/openqasm.ts";

      const menuToggle = document.querySelector(".menu-toggle");
      const primaryNav = document.querySelector("#primary-nav");
      menuToggle?.addEventListener("click", () => {
        const open = primaryNav?.dataset.open !== "true";
        if (primaryNav) primaryNav.dataset.open = String(open);
        menuToggle.setAttribute("aria-expanded", String(open));
      });
      primaryNav?.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", () => {
          primaryNav.dataset.open = "false";
          menuToggle?.setAttribute("aria-expanded", "false");
        });
      });

      const nodeData = {
        keter: [
          "Keter / כתר",
          "Intent service. Establishes the governing run intention and top-level execution boundary.",
          "Machine role: intent / run initialization",
        ],
        chokhmah: [
          "Chokhmah / חכמה",
          "Generation service. Introduces candidate operations and new state into the execution path.",
          "Machine role: generation / operation proposal",
        ],
        binah: [
          "Binah / בינה",
          "Structure service. Shapes generated possibility into validated, bounded machine form.",
          "Machine role: structure / validation",
        ],
        daat: [
          "Da’at / דעת",
          "Observation boundary. Da’at remains visible but distinct from the ten sefirot and marks checkpointed knowledge of machine state.",
          "Machine role: observation service + dimmed Da’at boundary indicator",
        ],
        chesed: [
          "Chesed / חסד",
          "Expansion service. Permits state to propagate where the active contract allows additional reach.",
          "Machine role: expansion / propagation",
        ],
        gevurah: [
          "Gevurah / גבורה",
          "Constraint service. Applies limits, rejects invalid transitions, and keeps the runtime fail-closed.",
          "Machine role: constraint / guardrails",
        ],
        tiferet: [
          "Tiferet / תפארת",
          "Coherence service. Reconciles constrained and expansive state into a stable execution view.",
          "Machine role: coherence / state reconciliation",
        ],
        netzach: [
          "Netzach / נצח",
          "Continuation service. Carries accepted state forward through deterministic execution.",
          "Machine role: continuation / sequencing",
        ],
        hod: [
          "Hod / הוד",
          "Representation service. Serializes internal state into inspectable traces, projections, and records.",
          "Machine role: representation / serialization",
        ],
        yesod: [
          "Yesod / יסוד",
          "Integration service. Binds trace, projection, provenance, and physical output into a coherent run artifact.",
          "Machine role: integration / Run Passport binding",
        ],
        malchut: [
          "Malchut / מלכות",
          "Output service. Manifests the accepted run as files, transport frames, acknowledgements, and visible machine state.",
          "Machine role: output / physical manifestation",
        ],
      };
      const nodeOrder = Object.keys(nodeData);
      const nodes = [...document.querySelectorAll(".node[data-node]")];
      const nodeInspector = document.querySelector("#sefirah-description");
      const nodeName = document.querySelector("#node-name");
      const nodeDescription = document.querySelector("#node-description");
      const nodeTechnical = document.querySelector("#node-technical");
      let activeNode = "tiferet";

      function selectNode(name, reveal = false) {
        if (!nodeData[name]) return;
        activeNode = name;
        nodes.forEach((node) =>
          node.classList.toggle("active", node.dataset.node === name),
        );
        document.querySelectorAll(".path").forEach((path) => {
          path.classList.toggle(
            "active",
            path.dataset.nodes?.split(" ").includes(name),
          );
        });
        const [title, description, technical] = nodeData[name];
        nodeName.textContent = title;
        nodeDescription.textContent = description;
        nodeTechnical.textContent = technical;
        if (reveal) revealNodeDetails();
      }

      function revealNodeDetails() {
        nodeInspector.classList.add("is-open");
        if (window.matchMedia("(max-width: 900px)").matches) {
          nodeInspector.scrollIntoView({ behavior: "smooth", block: "center" });
          nodeInspector.focus({ preventScroll: true });
        }
      }

      nodes.forEach((n) => {
        n.addEventListener("click", () => selectNode(n.dataset.node, true));
        n.addEventListener("keydown", (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            selectNode(n.dataset.node, true);
          }
        });
      });
      document
        .querySelector("#node-previous")
        ?.addEventListener("click", () => {
          const index = nodeOrder.indexOf(activeNode);
          selectNode(
            nodeOrder[(index - 1 + nodeOrder.length) % nodeOrder.length],
          );
        });
      document.querySelector("#node-next")?.addEventListener("click", () => {
        const index = nodeOrder.indexOf(activeNode);
        selectNode(nodeOrder[(index + 1) % nodeOrder.length]);
      });
      document
        .querySelector("#return-to-tree")
        ?.addEventListener("click", () => {
          nodeInspector.classList.remove("is-open");
          document.querySelector(`#${activeNode}`)?.focus();
          document
            .querySelector("#tree")
            ?.scrollIntoView({ behavior: "smooth", block: "center" });
        });
      selectNode("tiferet");

      const sourceInput = document.querySelector("#qasm-source");
      const qasmOutput = document.querySelector("#qasm-output");
      const qasmStatus = document.querySelector("#qasm-status");
      const compileButton = document.querySelector("#compile-qasm");
      const qasmMap = document.querySelector("#qasm-map");

      IVRIT_OPENQASM_GATES.forEach((gate) => {
        const item = document.createElement("li");
        item.innerHTML = `<b lang="he">${gate.letter}</b><code>${gate.operation}</code>`;
        item.title = `${gate.label} / arity ${gate.arity}`;
        qasmMap.append(item);
      });

      function renderQasm() {
        try {
          const source = sourceInput.value.trim();
          qasmOutput.textContent = compileIvritToOpenQasm(source, 3);
          qasmStatus.textContent =
            "CANONICAL CORPUS EXTERNALLY VALIDATED / broader review requested";
          qasmStatus.dataset.state = "valid";
        } catch (error) {
          qasmOutput.textContent = "";
          qasmStatus.textContent =
            error instanceof Error ? error.message : String(error);
          qasmStatus.dataset.state = "invalid";
        }
      }
      compileButton.addEventListener("click", renderQasm);
      sourceInput.addEventListener("keydown", (event) => {
        if (event.key === "Enter") renderQasm();
      });
      renderQasm();
    